module.exports = function(h, row) {
    return (
        <span class={row.status ? 'label green' : 'label'}>
            {row.status ? 'ACTIVE' : 'INACTIVE'}
        </span>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/status.jsx